// Identificador único: UUID si el navegador lo soporta, con fallback no-cripto.
// Vive aquí (y no en index.ts) para que transport.ts pueda usarlo en el eventId
// por evento sin crear un import circular transport→index.
export function uid(): string {
  try {
    if (crypto?.randomUUID) return crypto.randomUUID();
  } catch {
    /* noop */
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
